import type { HTMLAttributes } from "react";

import type { TImageProps } from "@/ui/components/primitives/Image";
import type { DefinedDefaults } from "@/ui/lib";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TPolaroidImageProps = {
  image: TImageProps;
  rotation?: number;
} & HTMLAttributes<HTMLDivElement>;

type TPolaroidImageDefaults = DefinedDefaults<TPolaroidImageProps, "rotation">;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const POLAROID_IMAGE_DEFAULTS = {
  rotation: -3,
} satisfies TPolaroidImageDefaults;
